/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppVersionDelete
 */
export interface AppVersionDelete {
    /**
     * 
     * @type {string}
     * @memberof AppVersionDelete
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AppVersionDelete
     */
    object_type: string;
}

/**
 * Check if a given object implements the AppVersionDelete interface.
 */
export function instanceOfAppVersionDelete(value: object): value is AppVersionDelete {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    return true;
}

export function AppVersionDeleteFromJSON(json: any): AppVersionDelete {
    return AppVersionDeleteFromJSONTyped(json, false);
}

export function AppVersionDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppVersionDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object_type': json['object_type'],
    };
}

export function AppVersionDeleteToJSON(json: any): AppVersionDelete {
    return AppVersionDeleteToJSONTyped(json, false);
}

export function AppVersionDeleteToJSONTyped(value?: AppVersionDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'object_type': value['object_type'],
    };
}

